import { throttle } from 'utils/functions'

const SCROLL_DISTANCE_TO_BUTTON_APPEAR = 20 //px
const BUTTON_OFFSET_FROM_BOTTOM = 70 //px

/**
 * Check if user scroll enought to show button.
 *
 * @return {*}  {boolean}
 */
const isScrollFarEnought = (): boolean =>
  document.body.scrollTop > SCROLL_DISTANCE_TO_BUTTON_APPEAR ||
  document.documentElement.scrollTop > SCROLL_DISTANCE_TO_BUTTON_APPEAR

/**
 * Handle button to scroll up behavior.
 *
 */
const buttonVisibility = (): void => {
  const $backToTopButton = document.querySelector<HTMLDivElement>('.button-back-to-top')

  if ($backToTopButton) {
    $backToTopButton.style.transform = isScrollFarEnought()
      ? `translateY(-${BUTTON_OFFSET_FROM_BOTTOM}px)`
      : `translateY(-${BUTTON_OFFSET_FROM_BOTTOM}px)`
  }
}

/**
 * Scroll user viewport to top.
 *
 */
const scrollPageToTop = (): void => window.scrollTo(0, 0)

export default function initButtonVisibility(): void {
  const $backToTopButton = document.querySelector<HTMLDivElement>('.button-back-to-top')
  if ($backToTopButton) {
    window.onscroll = throttle((): void => {
      buttonVisibility()
    }, 500)
    $backToTopButton.addEventListener('click', scrollPageToTop)
  }
}
